<template>
  <v-card outlined class="pa-3 font-weight-light">
    <div class="d-flex grow flex-wrap">
      <v-sheet style="top: -20px; position: relative; height: fit-content;" class="pa-3 rounded text-start" elevation="3" :color="color" dark>
        <v-icon>{{icon}}</v-icon>
      </v-sheet>
      <v-spacer></v-spacer>
      <div class="text-right pb-1">
        <div class="body-3 grey--text">{{title}}</div>
        <h3 class="display-1 font-weight-light text--primary">{{value | number}}</h3>
      </div>
    </div>
    <template v-if="$slots.legend">
      <v-divider class="mb-2"></v-divider>
      <div class="caption grey--text">
        <slot name="legend"></slot>
      </div>
    </template>
  </v-card>
</template>

<script>
export default {
  props: ['icon', 'color', 'title', 'value']
}
</script>

<style lang="scss" scoped>
</style>